import { IProjectTimeZoneResponseDto } from './dto/ProjectTimeZoneDto'
import { api } from './BaseApi'

export const projectTimeZoneApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getProjectTimeZone: builder.query<
      IProjectTimeZoneResponseDto & { receivedAt: number },
      null
    >({
      query: () => ({
        url: '/project_time_zone/get_project_time_zone/',
      }),
      transformResponse: (response: IProjectTimeZoneResponseDto) => ({
        ...response,
        receivedAt: Date.now(),
      }),
    }),
  }),
})

export const { useGetProjectTimeZoneQuery } = projectTimeZoneApi
